import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/workspace/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CustomCursor"] */ "/workspace/src/components/custom-cursor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/workspace/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/src/context/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryProvider"] */ "/workspace/src/context/CategoryContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CVProvider"] */ "/workspace/src/context/CVContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FriendProvider"] */ "/workspace/src/context/FriendContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GameReviewProvider"] */ "/workspace/src/context/GameReviewContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceProvider"] */ "/workspace/src/context/ServiceContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/workspace/src/context/SettingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportProvider"] */ "/workspace/src/context/SupportContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/workspace/src/context/ThemeContext.tsx");
